import { provideHttpClient } from '@angular/common/http';
import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import { RumProvider } from '@insolution/audit-data-access';
import { AuthService } from '@insolution/auth-data-access';
import { BrandingService } from '@insolution/branding-util';
import { AppVersionService } from '@insolution/core-data-access';
import { apolloFactory } from '@insolution/graphql-data-access';
import { HELP_API_URL } from '@insolution/help-data-access';
import { LazyTranslateLoader } from '@insolution/language-data-access';
import { provideTranslateLoader, provideTranslateService } from '@ngx-translate/core';
import { provideApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(appRoutes),
    provideHttpClient(),
    { provide: HELP_API_URL, useValue: environment.helpApiUrl },
    provideApollo(() => {
      const httpLink = inject(HttpLink);
      return apolloFactory(httpLink, environment.graphqlEndpoint, environment.region);
    }),
    RumProvider.provide({
      appId: environment.rumConfiguration.appMonitorId,
      identityPoolId: environment.rumConfiguration.identityPoolId,
      region: environment.rumConfiguration.region,
      appVersion: environment.rumConfiguration.appVersion,
      sessionSampleRate: environment.rumConfiguration.sampleRate,
    }),
    provideTranslateService({
      loader: provideTranslateLoader(LazyTranslateLoader),
      fallbackLang: 'en-US',
      lang: 'en-US',
    }),
    provideAppInitializer(() => {
      inject(BrandingService).applyBranding();
    }),
    provideAppInitializer(() => {
      const authService = inject(AuthService);
      return authService.waitForLoginStatus();
    }),
    provideAppInitializer(() => {
      const appVersionService = inject(AppVersionService);
      return appVersionService.startVersionCheck();
    }),
  ],
};
